export enum OnboardingStepKey {
  CARD_DESIGN_SELECTION = 'chooseCardDesign',
  CONGRATS = 'onboardingCongrats',
  CREATE_PIN = 'createPin',
  COPY_CVV = 'copyCvv',
  ALL_SET = 'onboardingComplete',
}

export type OnboardingStep = {
  key: OnboardingStepKey;
  content?: Record<string, any>;
};

export const getMockSteps = (isBooking: boolean): OnboardingStep[] => [
  {
    key: OnboardingStepKey.CARD_DESIGN_SELECTION,
    content: {
      title: 'Choose your card design',
      subtitle:
        'Pick a look for your physical and digital card to complete your offer.',
    },
  },
  {
    key: OnboardingStepKey.CONGRATS,
    content: {
      title: 'Congratulations on your new card!',
      subtitle: 'A few things to know',
      listItems: [
        {
          icon: 'wallet',
          text: `Your physical card is on its way${
            isBooking
              ? ', and your virtual card is saved to your Booking.com account'
              : ''
          }.`,
        },
        {
          icon: 'cardNumber',
          text: 'Your virtual card in your Imprint account is ready to use.',
        },
        {
          icon: 'lock',
          text: 'Set up your PIN now for easier access to your Imprint account later.',
        },
      ],
    },
  },
  {
    key: OnboardingStepKey.CREATE_PIN,
  },

  ...(isBooking
    ? [
        {
          key: OnboardingStepKey.COPY_CVV,
          content: {
            title: 'Need to check out now?',
            subtitle:
              'Your three-digit security code (CVV) is required for Booking.com purchases. Tap the CVV to copy it, then paste it at checkout to complete your first purchase.',
            copyButtonText: 'Copy CVV',
            skipButtonText: 'Not now',
            copySuccessText: 'CVV is copied successfully',
          },
        },
      ]
    : []),
  {
    key: OnboardingStepKey.ALL_SET,
    content: {
      title: 'You are all set!',
      subtitle:
        'You can always find your card details in your Imprint account. Keep an eye on your inbox—Imprint will send an email with everything you need to set up your new account. We’re now taking you back to {merchantName}.',
    },
  },
];
